/**
 * Amplify 等が付与する末尾スラッシュを除去する（ルート `/` はそのまま）
 *
 * pathnameToDataViewMode / isValidTabIdAndPathnameCombination などと
 * 同じ正規化方針に揃え、お気に入り・GA タイトル判定の不一致を防ぐ
 */
export const normalizePathname = (path: string): string =>
  path === '/' ? path : path.replace(/\/$/, '');
